import React from "react";
import {Button} from "react-bootstrap";
import Loading from "./Loading.gif";

class InsertContentsPDF extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data:{
            bookId: props.bookId,
            book_cover: "",
            book_file: "",
            total_pages: 0
        },
        fileUrl: "",
        imageUploading: false,
        failed: false,
        fs: "No File Choosen...",
        fss: false,
        old_total_pages: 0
      };
    };
    componentDidMount(){
        if(this.props.books){
        if(this.props.books.book_cover !== undefined){
            this.setState({"fs": this.props.books.book_cover, "old_book_cover": this.props.books.book_cover, "old_book_file": this.props.books.book_file});
        }
        if(this.props.books.book_file !== undefined){
            this.setState({"fss": this.props.books.book_file});
        }
        if(this.props.books.total_pages !== undefined){
            this.setState({data: {...this.state.data, "total_pages": this.props.books.total_pages}});
            this.setState({"old_total_pages": this.props.books.total_pages});
        }}
    };
    ptf = e => {
        const book_file = this.state.data.book_file;
        this.setState({data: {...this.state.data, book_fileName: book_file.name, book_fileType: book_file.type}});
    };
    filechange = e => {
        this.setState({imageUploading: true, failed: false})
        try{
        var files = e.target.files[0];
        this.setState({fileUrl: URL.createObjectURL(files),imageUploading: false, fs: files.name, data:{...this.state.data, book_cover:files}})
        }catch{
            this.setState({fileUrl: "",failed: true, imageUploading: false})
        }
    };
    filechangee = e => {
        try{
        var files = e.target.files[0];
        this.setState({fss: files.name, data:{...this.state.data, book_file:files}})
        }catch{
            this.setState({fileUrl: "",failed: true, imageUploading: false})
        }
    }
    onsubmit = (e) => {
        e.preventDefault();
    };
    uploadImage = () => {
        var formData = new FormData();
        formData.append('filetoupload', this.state.data.book_cover, this.state.data.book_cover.name)
        this.props.uploadBookCover(formData);
    };
    changeName = () => {
        this.props.changeName(this.state.data.name);
    };
    ptf = e => {
        var book_file = this.state.data.book_file;
        this.setState({data: {...this.state.data, book_fileName: book_file.name, book_fileType: book_file.type}});
    };
    ptff = e => {
        var formDataa = new FormData();
        formDataa.append('filetoupload', this.state.data.book_file, this.state.data.book_file.name)
        this.props.uploadBookFile(formDataa);
    };
    chPag = e => {
        e.preventDefault();
        const {total_pages} = this.state.data;
        this.setState({old_total_pages: total_pages});
        this.props.chPag(this.state.data.total_pages);
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    render(){
        const {book_cover, book_file,
            book_fileName, book_fileType, total_pages} = this.state.data;
        const {imageUploading, failed, fileUrl, fs, fss, old_book_cover, old_total_pages} = this.state;
        const {filechange,filechangee, onsubmit, onchange, chPag} = this;
        return(
            <div className="form_comn main_form">
                <form onSubmit={onsubmit}>
                    <div className="cfg">
                        <label className="cfg-label">{old_book_cover ? "Change the": "Upload the"} Book Cover: </label>

                            <div className="cfg2">
                            {!imageUploading && old_book_cover && !fileUrl && (
                            <img 
                                src={"/root/user/"+old_book_cover}
                                className="cpreview" 
                                alt="book_cover" 
                            />
                            )}
                        {!imageUploading ? fileUrl && (
                        <img 
                            src={fileUrl}
                            className="cpreview" 
                            alt="book_cover" 
                        />
                        ):<img 
                            src={Loading}
                            className="editGravatarr" 
                            alt="gravatar" 
                        />}
                        {failed && (
                            <h1 className="failecd">Failed</h1>
                        )}
                        <input 
                            type="file"
                            onChange={filechange}
                            accept=".png, .jpg, .bmp"
                            id="actual_btn"
                            hidden
                        /><label htmlFor="actual_btn" className="btn-filee">Choose File</label><span className="fs"></span></div>
                    </div><br/><br/>
                    {book_cover && !failed && (
                    <button className="btn-upc" onClick={this.uploadImage}>Upload</button>)}
                        <br/><label className="pdf_s">***ONLY PDF FILES ARE SUPPORTED</label>
                    <div className="cfg2nd">
                        <label className="cfg2nd-label">{fss ? "Change the": "Upload the"} Book File: </label>

                            <div className="cfg22nd">
                        <input 
                            type="file"
                            onChange={filechangee}
                            accept=".pdf"
                            id="actual_btnn"
                            hidden
                        /><label htmlFor="actual_btnn" className="btn-uploadBook">Choose File</label><span className="fs cfs"></span></div>
                    </div><br/>
                    {book_file && (
                    <button className="btn-ptf" onClick={this.ptf}>Process the File</button>)}
                    {book_fileName && (
                        <div className="file_info">
                            <h1 className="text-center">Showing File Info</h1>
                            <p><b>Name: </b>{book_fileName}</p>
                            <p><b>Type: </b>{book_fileType}</p>
                        </div>
                    )}
                    {book_fileName && (
                    <button className="btn-upb" onClick={this.ptff}>Upload</button>)}
                    <div className="mt-5">
                        <label htmlFor="total_pages">Total Pages: </label>
                        <input 
                            type="number" 
                            id="total_pages" 
                            value={total_pages}
                            name="total_pages"
                            className="form_control_c"
                            onChange={onchange}
                        /><br/>
                        {total_pages !== old_total_pages && (
                            <Button variant="success" onClick={chPag}>Change</Button>
                        )}
                    </div><br/>
                </form>
            </div>
        );
    };
};

export default InsertContentsPDF;